'use strict';

import { graphql, useStaticQuery } from 'gatsby';
import { useMemo } from 'react';

import { getVariantByLanguage, sortObject } from '../utils/helpers';
import useTranslation from './use_translation';

function useArticle({
	exclude_articles = null,
	include_articles = null,
	include_groups = null,
	include_markers = null,
	include_products = null,
	include_types = null,
	limit,
	sort,
} = {}) {
	const { language } = useTranslation('hooks_use_product');
	const data = useStaticQuery(graphql`
		query ArticleHook {
			allArticle(sort: { published_at: DESC }) {
				nodes {
					article_id
					fields {
						files_header_url_src {
							childImageSharp {
								gatsbyImageData(width: 320)
							}
						}
					}
					groups
					markers
					products
					published_at
					type
					article_variants {
						article_variant_id
						content
						excerpt
						language {
							code
						}
						slug
						subtitle
						title
					}
				}
			}

			locales: allLocale {
				...translationFields
			}
		}
	`);

	const out = useMemo(() => {
		const article_data = data.allArticle.nodes;
		let tmp = article_data
			.map((item) => {
				if (exclude_articles && exclude_articles.includes(item.article_id)) {
					return;
				} else if (
					include_articles &&
					!include_articles.includes(item.article_id)
				) {
					return;
				} else if (
					include_groups &&
					!include_groups.some((value) => {
						return item?.groups?.includes(value);
					})
				) {
					return;
				} else if (
					include_markers &&
					!include_markers.some((value) => {
						return item?.markers?.includes(value);
					})
				) {
					return;
				} else if (
					include_products &&
					!include_products.some((value) => {
						return item?.products?.includes(value);
					})
				) {
					return;
				} else if (include_types && !include_types.includes(item.type)) {
					return;
				}

				item.article_variant = getVariantByLanguage(
					language,
					item.article_variants,
				);
				if (!item.article_variant) return;

				return item;
			})
			.filter(Boolean);

		if (sort) {
			tmp = sortObject(tmp, sort);
		}

		const total = tmp.length;
		if (limit && tmp) tmp = tmp.slice(0, limit);

		return { count: { items: tmp.length, total }, items: tmp };
	}, [
		data,
		exclude_articles,
		include_articles,
		include_groups,
		include_markers,
		include_products,
		include_types,
		language,
		limit,
		sort,
	]);

	return out;
}

export default useArticle;
